import { render, staticRenderFns } from "./VerificationBadge.vue?vue&type=template&id=e56541fa&scoped=true&"
import script from "./VerificationBadge.vue?vue&type=script&lang=js&"
export * from "./VerificationBadge.vue?vue&type=script&lang=js&"
import style0 from "./VerificationBadge.vue?vue&type=style&index=0&id=e56541fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e56541fa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VIcon,VTooltip})
